export enum ActivityTopicKeys {
  expirationWarning = "expiration-warning",
  expirationWarningCleared = "expiration-warning-cleared",
  sessionExtensionError = "session-extension-error",
}
